import { telegramAuthClientPlugin } from '@coas/better-auth-telegram-plugin/client';
import { emailOTPClient, inferAdditionalFields, phoneNumberClient } from 'better-auth/client/plugins';
import { createAuthClient } from 'better-auth/react';
import { toast } from 'sonner';
import { env } from '~/env';

export const authClient = createAuthClient({
    baseURL: env.NEXT_PUBLIC_SERVER_URL,
    plugins: [
        telegramAuthClientPlugin(),
        emailOTPClient(),
        phoneNumberClient(),
        inferAdditionalFields({
            user: {
                role: { type: 'string' },
            },
        }),
    ],
    fetchOptions: {
        credentials: 'include',
        onError: async context => {
            const { response } = context;
            if (response.status !== 429) return;

            const ra = response.headers.get('x-retry-after') ?? response.headers.get('X-Retry-After');

            const seconds = ra ? Math.ceil(Number(ra)) : null;

            if (seconds) {
                toast.warning(`You can resend the message in ${seconds} seconds`);
            } else {
                toast.warning('Too many attempts, please try again later');
            }
        },
    },
});

export const useSessionAdmin = () => {
    const { data, isPending, error } = authClient.useSession();
    const isAdmin = data?.user.role === 'ADMIN';
    return { isPending, isAdmin, error };
};

export const { useSession } = authClient;
